import styled from "styled-components";

export const Container = styled.div`
  width: 50%;
  position: relative;
  right: 0;
  top: 0;
  z-index: 1;
  background: whitesmoke;
  height: 100%;

  iframe {
    border: none;
    outline: none;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    opacity: 0.5;
  }

  @media (max-width: 800px) {
    width: 100%;
    position: absolute;
  }
`;
